<template>
<div>
            <section>
            <v-parallax src="static/img/background.jpg" height="500">
              <v-layout
                column
                align-center
                justify-center
              >
                <h1 class="black--text mb-2 display-1 text-xs-center">Cakes by</h1>
                <h1 class="black--text mb-4 display-2 text-xs-center" @click="secretButton">Karen Richardson</h1>
                <p class="black--text mb-2 title text-xs-center font-weight-light">Supplying a wide range of cakes in the Birmingham, Solihull and Tamworth areas.</p>
                <v-btn
                  class="primary mt-5"
                  dark
                  fab
                  @click="scrollPage"
                >
                  <v-icon>expand_more</v-icon>
                </v-btn>
              </v-layout>
            </v-parallax>
          </section>
          <section id="scroll-target">
        <v-layout
          column
          wrap
          class="my-5"
          align-center
        >
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">Hi, I'm Karen Richardson</h2>
              <span class="subheading">
                 
              </span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-start>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <img src="static/img/wedding.jpg" style="height:150px; width:150px; border-radius:50%"/>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Wedding Cakes</div>
                    </v-card-title>
                    <v-card-actions class="layout justify-center">
                      <v-btn outline class="primary primary--text" to="/wedding">View Images</v-btn>
                    </v-card-actions>
                    <v-card-text>
                      Beautiful wedding cakes made to your own design.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <img src="static/img/birthday.jpg" style="height:150px; width:150px; border-radius:50%"/>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Birthday Cakes</div>
                    </v-card-title>
                    <v-card-actions class="layout justify-center">
                      <v-btn outline class="primary primary--text" to="/birthday">View Images</v-btn>
                    </v-card-actions>
                    <v-card-text>
                      I offer a wide variety of Birthday cake designs for your special occasion.  
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <img src="static/img/cupcakes.jpg" style="height:150px; width:150px; border-radius:50%"/>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Cup Cakes</div>
                    </v-card-title>
                    <v-card-actions class="layout justify-center">
                      <v-btn outline class="primary primary--text" to="/cupcakes">View Images</v-btn>
                    </v-card-actions>
                    <v-card-text>
                      A wide variety of cupcakes are available to your choice. 
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>
    </div>
</template>

<script>
export default {
  data () {
    return {
      fab: false,
      count: 0
    }
  },
  methods: {
    scrollPage () {
      window.scrollTo({
        top: 500,
        behavior: 'smooth'
      })
    },
    secretButton () {
      this.count++
      if (this.count === 10) {
        this.$router.push('/edit')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.display-2, .display-1{
  font-weight: normal;
  font-family: 'Pacifico', cursive!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue